export default "<app-progress-bar [value]=\"resource.amount\" [max]=\"resource.max\"></app-progress-bar>\n"